import { useEffect, useRef } from 'react';

/**
 * Hook that returns promise for asynchronously resolved spaceId. This is written with the assumption that
 * the spaceId will change from null to a valid value once the higher level component has fetched the spaceId.
 */
export function useSpaceIdPromise(spaceId?: string | null) {
	const resolveFnRef = useRef<any>(null);
	const spaceIdPromiseRef = useRef<Promise<string> | null>(null);
	if (!spaceIdPromiseRef.current) {
		spaceIdPromiseRef.current = new Promise((resolve) => {
			resolveFnRef.current = resolve;
		});
	}

	useEffect(() => {
		if (spaceId || spaceId === '') {
			resolveFnRef.current(spaceId);
		}
	}, [spaceId]);

	return spaceIdPromiseRef.current!;
}
